import { render, staticRenderFns } from "./Biljetter.vue?vue&type=template&id=6c7c8bbe"
import script from "./Biljetter.vue?vue&type=script&lang=js"
export * from "./Biljetter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports